// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../channels2022/node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(function(i){return i[1]});
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".icon-bg-shine[data-v-965caca2]{color:#e1e2e4}.icon-bg-shine[data-v-965caca2]  path{fill:url(#icon-bg-shine-gradient)}.ui-dark .icon-bg-shine[data-v-965caca2]{color:#2a2b3a}.ui-dark .icon-bg-shine[data-v-965caca2]  path{fill:url(#icon-bg-shine-gradient-dark)}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
module.exports = ___CSS_LOADER_EXPORT___;
